import { render, staticRenderFns } from "./SaleTypeEditMailSettings.vue?vue&type=template&id=0bb1f432"
import script from "./SaleTypeEditMailSettings.vue?vue&type=script&lang=ts"
export * from "./SaleTypeEditMailSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb1f432')) {
      api.createRecord('0bb1f432', component.options)
    } else {
      api.reload('0bb1f432', component.options)
    }
    module.hot.accept("./SaleTypeEditMailSettings.vue?vue&type=template&id=0bb1f432", function () {
      api.rerender('0bb1f432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleTypeEditMailSettings.vue"
export default component.exports